import { EditorThemeClasses } from "lexical";

export const LexicalEditorTheme: EditorThemeClasses = {
  paragraph: "mb-1",
  quote: "border-l-4 border-gray-300 pl-4 italic",
  heading: {
    h1: "text-3xl font-semibold leading-normal mb-2",
    h2: "text-2xl font-semibold leading-normal mb-2",
    h3: "text-xl font-semibold leading-normal mb-2",
  },
  text: {
    bold: "font-bold",
    underline: "underline",
    italic: "italic",
    strikethrough: "line-through",
    code: "bg-gray-100 px-1 py-0.5 rounded font-mono text-sm",
  },
  link: "text-icon-reply cursor-pointer hover:underline",
};
